import React from 'react';
import PropTypes from 'prop-types';
import TcBreadcrumbService from './tc.breadcrumb.service';
import { Breadcrumb } from 'react-bootstrap';

const TcBreadcrumb = ({ buildPaths, flows, location } = {}) => {
  const breadcrumbPaths = buildPaths(flows, location);
  const paths = TcBreadcrumbService.buildBreadcrumb(breadcrumbPaths);

  return paths.length > 1 && <Breadcrumb>{paths}</Breadcrumb>;
};

TcBreadcrumb.propTypes = {
  buildPaths: PropTypes.func,
  flows: PropTypes.object.isRequired,
  location: PropTypes.object
};

export default TcBreadcrumb;
